import { useEffect, forwardRef } from 'react';

const InquiryForm = forwardRef((props, ref) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://widgets.nopaperforms.com/emwgts.js';
    document.body.appendChild(script);
  }, []);

  return (
    <div
      ref={ref}
      className="text-white rounded-lg shadow-xl w-full max-w-md bottom-[0px] md:bottom-[-34px] relative"
    >
      <div className="pt-[30px] pb-[30px] bg-white w-full text-blue-900 rounded-t-[10px]">
        <h3 className="text-2xl font-bold text-center">Inquiry Now</h3>
      </div>

      <div className="bg-[#282365] opacity-95 rounded-b-[10px]">
        {/* Nopaperforms widget placeholder */}
        <div
          className="npf_wgts rounded-b-[10px]"
          data-height="700px"
          data-w="898d4cde4c4a717d12b34937d505dd55"
        ></div>
      </div>
    </div>
  );
});

export default InquiryForm;
